let baseApi;

// 自动获取动态域名
var host = window.location.host;
let http = document.location.protocol; // 浏览器协议
let serverDomain = ''; // 服务端域名
if (host.indexOf('.') != -1) {
  var hostN = host.substring(host.indexOf("."));
  if (hostN.indexOf(':') == -1) {
    serverDomain = hostN.slice(0) + '/';
  } else {
    // serverDomain = hostN.substring(hostN.indexOf(".", 1)).split(':')[0] + '/';
    serverDomain = hostN.split(':')[0] + '/';
  }
}

if(serverDomain.includes('.goago.cn')) {
  baseApi = http + '//ndts-sso' + serverDomain + 'web/'; // 后端接口域名
  // baseApi = 'https://ndts-sso' + serverDomain + 'web/';
  // baseApi = 'https://ypxt.nmpa.gov.cn:9095/web/'
} else {
  // baseApi = 'https://ypxt.nmpa.gov.cn:9095/web/'; // 后端接口域名
  baseApi = 'https://ypxt.nmpa.gov.cn/web/'; // 后端接口域名
}
// baseApi = `/ApiNew/web/`

const baseConfig = {
  BASEAPI: baseApi, // 后端接口域名
};

export default baseConfig;